// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import PinInputController from "./pin_input_controller"
application.register("pin-input", PinInputController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import SubmitSpinnerController from "./submit_spinner_controller"
application.register("submit-spinner", SubmitSpinnerController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TypeaheadController from "./typeahead_controller"
application.register("typeahead", TypeaheadController)
